// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__uIXev","resendInfoText":"OnGoingPaymentBox_resendInfoText__2ta25"};